<template>
  <div class="grid-container">
    <NavBarComponent />

    <router-view />

    <FooterComponent />

  </div>
</template>

<script>
import NavBarComponent from '@/components/NavBarComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import '@/assets/style.css';  // Import global styles
import '@/font-awesome/css/font-awesome.min.css';

export default {
  name: "App",
  components: {
    NavBarComponent,
    FooterComponent
  },
};
</script>
